import { render, staticRenderFns } from "./PrizeDisplay.vue?vue&type=template&id=67c8a3da&lang=pug&"
import script from "./PrizeDisplay.vue?vue&type=script&lang=js&"
export * from "./PrizeDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports